<template>
    <div :style="tableLoaded ? 'padding: 1.25rem;' : ''" :class="showTableBarLoader ? 'disabled-custom-class' : ''">
        <data-table-collapse
            v-if="tableLoaded"
            :grandTotal="grandTotal"
            :grandTotalData="grandTotalData"
            :exportable="tablePermission"
            :search="false"
            :rows="rowData"
            :columns="columnData"
            :perPage="perPage"
            :rowsCount="rowsCount"
            :currentPage="currentPage"
            :pageCount="pageCount"
            @changePage="changePage"
            @orderByEvent="orderByEvent"
            @exportButtonClick="onExportButton"
            @rowClickPDF="onPDF"
            >
        </data-table-collapse>

        <b-btn class="btn btn-dark mt-3" @click="goToCalculation" v-if="tableLoaded && overviewPermission">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{go_to_button_title}}
        </b-btn>

        <confirm-dialog ref="pdfModal" :title="$t('modal.general.download_pdf')" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTableCollapse from '@/components/global/tables/datatables/DataTableCollapse.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';

export default {
    name: 'progress_calculation_table',
    components: {
        DataTableCollapse,
        ConfirmDialog,
        miniToastr,
    },
    props: {
        grandTotal: {
            type: Boolean,
            default: false
        },
        columnData: {
            type: Array,
            required: true,
        },
        disciplineId: {
            type: Number,
            required: true,
        },
        tableName: {
            type: String,
            default: null,
            required: true
        },
        tableInfo: {
            type: Object,
            default: null,
        },
        section: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            overviewPermission: false,
            tablePermission: false,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            rowData: [],
            grandTotalData: {},
            showTableBarLoader: false,
            go_to_button_title: '',
        }
    },
    mounted() {
        this.waitForTable().then(res => {
            this.pricesPermission = !this.$store.getters.hasPermission(['project_prices']);

            switch (this.section) {
                case 'piping':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_piping'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_piping'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_piping_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_piping');
                break;
                case 'equipment':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_equipment'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_equipment'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_equipment_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_equipment');
                break;
                case 'steel':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_steel'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_steel'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_steel_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_steel_structure');
                break;
                case 'civil':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_civil'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_civil'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_civil_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_civil_works');
                break;
                case 'ei':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_ei'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_ei'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_ei_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_ei_works');
                break;
                case 'other':
                    this.overviewPermission     = this.$store.getters.hasPermission(['project_calculation_overview_other'], ['read']);
                    this.tablePermission        = this.$store.getters.hasPermission(['project_progress_calculation_other'], ['read']);
                    this.getAllValuesPermission = this.$store.getters.hasPermission(['project_progress_calculation_other_values']);
                    this.go_to_button_title     = Vue.i18n.translate('general.buttons.go_to.go_to_overview_other_works');
                break;
            }

            var newColumns = [];

            if (this.getAllValuesPermission) {
                if (this.pricesPermission) {
                    newColumns = [
                        {
                            field: 'total_weight',
                            label: Vue.i18n.translate('table.total_weight'),
                            html: false,
                            numeric: false,
                        },
                        {
                            field: 'progress_value_work_status_weight',
                            label: Vue.i18n.translate('table.progress_value_work_status_weight'),
                        },
                        {
                            field: 'progress_value_work_weight',
                            label: Vue.i18n.translate('table.progress_value_work_weight'),
                        },
                        {
                            field: 'percent_progress_value_work_weight',
                            label: Vue.i18n.translate('table.percent_progress_value_work_weight'),
                        }   
                    ];
                } else {
                    newColumns = [
                        {
                            field: 'total_price',
                            label: Vue.i18n.translate('table.total_price'),
                            html: false,
                            numeric: false,
                        },
                        {
                            field: 'total_price_work',
                            label: Vue.i18n.translate('table.total_price_work'),
                            html: false,
                            numeric: false,
                        },
                        {
                            field: 'total_weight',
                            label: Vue.i18n.translate('table.total_weight'),
                            html: false,
                            numeric: false,
                        },
                        {
                            field: 'progress_value_work_status',
                            label: Vue.i18n.translate('table.progress_value_work_status'),
                        },
                        {
                            field: 'progress_value_work_status_weight',
                            label: Vue.i18n.translate('table.progress_value_work_status_weight'),
                        },
                        {
                            field: 'progress_value_work_calculation',
                            label: Vue.i18n.translate('table.progress_value_work_calculation'),
                        },
                        {
                            field: 'percent_progress_value_work_calculation',
                            label: Vue.i18n.translate('table.percent_progress_value_work_calculation'),
                        },
                        {
                            field: 'progress_value_work_weight',
                            label: Vue.i18n.translate('table.progress_value_work_weight'),
                        },
                        {
                            field: 'percent_progress_value_work_weight',
                            label: Vue.i18n.translate('table.percent_progress_value_work_weight'),
                        }   
                    ];
                }
            }

            newColumns.forEach(field => {
                this.columnData.push(field);
            });
        });
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        async waitForTable () {
            await this.onLoadTable();
        },
        async onLoadTable () {
            return new Promise((resolve, reject) => {
                this.showTableBarLoader = true;
                this.$emit('showSpinnerFunction', this.showTableBarLoader);
                http.route(this.tableName + '?project_id=' + this.$route.params.id + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[discipline_id]=' + this.disciplineId).get(this.tableInfo).then(response => {
                    if (!response.isError) {
                        this.perPage     = response.pagination.limit;
                        this.rowsCount   = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount   = response.pagination.totalPages;
                        let data         = response.data;
                        data.forEach(field => {
                            if (typeof response.other != 'undefined') {
                                if (typeof response.other.collapsible_headers != 'undefined') {
                                    field.collapsible_headers = response.other.collapsible_headers;
                                }

                                if (typeof response.other.grand_total != 'undefined' && this.grandTotal) {
                                   this.grandTotalData = response.other.grand_total;
                                }
                            }
                        });

                        this.rowData = data;
                        this.tableLoaded = true;
                        this.showTableBarLoader = false;
                        this.$emit('showSpinnerFunction', this.showTableBarLoader);

                        resolve();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });

                        this.showTableBarLoader = false;
                        this.$emit('showSpinnerFunction', this.showTableBarLoader);

                        resolve();
                    }
                });
            });
        },
        goToCalculation() {
            switch (this.section) {
                case 'piping':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_piping');
                break;
                case 'equipment':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_equipment');
                break;
                case 'steel':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_steel_structure');
                break;
                case 'civil':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_civil_works');
                break;
                case 'ei':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_ei_works');
                break;
                case 'other':
                    this.$router.push('/project/'+this.$route.params.id+'/calculation/overview_other_works');
                break;
            }
        },
        onExportButton() {
            let put_data = {
                export: 1,
                type: this.section,
                project_id: this.$route.params.id,
            };

            put_data['progress_calculation_' + this.section] = 1;
            
            http.route('project_calculation_'+this.section + '_progress').exportExcel(put_data, 'progress_'+this.section+'_calculation.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    if (response.data == false) {
                        this.errorMsg(Vue.i18n.translate('errors.export_error'));
                    } 
                } else {
                    this.successMsg(Vue.i18n.translate('general.projects.progress.calculation.progress_calculation_'+this.section+'.overview_title')  + ' ' + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onPDF (row) {
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                var newTableInfo = {};

                newTableInfo['export_progress_pdf'] = 1;

                let data = http.route('drawing/' + this.row.id).get(newTableInfo, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (typeof res == 'undefined') {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(res.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }

            this.$refs.pdfModal.hide();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/calculation/progress_calculation_table.vue